import { useLocation } from 'react-router-dom';
import { PATHS } from '@/const';
import { useIsVibeBuilderEnabled } from '@/hooks/useIsVibeBuilderEnabled';
import { useVibeBuilderConfigQuery } from '@/services/integration/integration.queries';
import useAppStore from '@/store/app';

export const useVibeModeDockAvailability = () => {
    const isAuthorized = useAppStore((state) => state.isAuthorized);
    const isVibeBuilderEnabled = useIsVibeBuilderEnabled();
    const { pathname } = useLocation();

    const { data: vibeBuilderConfig } = useVibeBuilderConfigQuery(isAuthorized);

    const isDockMounted = pathname !== PATHS.vibeBuilder;

    const dockClientSecret =
        isAuthorized && isVibeBuilderEnabled && isDockMounted
            ? vibeBuilderConfig?.clientSecret
            : undefined;

    return {
        isDockAvailable: Boolean(dockClientSecret),
        dockClientSecret
    };
};
